
import { mapState } from 'vuex';
import FooterBefore from '../home/view/FooterBefore.vue';
import AllFurnitureViewDynamicBanner from './view/DynamicBanner.vue';

export default {
  name: 'AllFurnitureView',
  components: {
    FooterBefore,
    AllFurnitureViewDynamicBanner,
  },
  props: {
    trendingFurniture: {
      type: Array,
    },
    dynamicBannerData: {
      type: Array,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState({
      headerData: (state) => state.headerData || {},
      footerIsRendered: (state) => state.footerIsRendered,
      footerData: (state) => state.footerData,
    }),
    filteredCategories() {
      return (this.headerData.navigationCategories?.subs || []).filter(
        (category) => category.name !== 'Clearance',
      );
    },
    deviceSpecificBanner() {
      let banners = [];

      if (!this.$isSpider) {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1264) {
          banners = this.dynamicBannerData.filter((banner) => banner.isDesktop);
        } else if (screenWidth >= 768) {
          banners = this.dynamicBannerData.filter((banner) => banner.isTablet);
        } else {
          banners = this.dynamicBannerData.filter((banner) => banner.isMobile);
        }
      } else if (this?.$device?.isTablet) {
        banners = this.dynamicBannerData.filter((banner) => banner?.isTablet);
      } else if (this?.$device?.isMobile) {
        banners = this.dynamicBannerData.filter((banner) => banner?.isMobile);
      } else {
        banners = this.dynamicBannerData.filter((banner) => banner?.isDesktop);
      }
      return banners;
    },
  },
  methods: {
    handleScrollToCategory(categoryId) {
      const section = this.$refs[`categorySection-${categoryId}`];
      if (section && section[0]) {
        section[0].scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('setFooterRender', false);
  },
};
